import script from "./ContactSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ContactSidebar.vue?vue&type=style&index=0&id=f09a9e7e&lang=scss"

const __exports__ = script;

export default __exports__